module.exports = __webpack_public_path__ + "img/xmxxLogo.9b8dcd4f.png";